import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-white" data-id="element-141" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-142" data-mp="223eltma3nb3z">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-mist-light border border-mist-dark rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-sm" data-id="element-143" data-mp="222dbjk0wqsnb">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold" data-id="element-144" data-mp="1j4k9sl20sori" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold text-navy-dark mb-8" data-id="element-145" data-mp="1j6dcxqdfcqur">
            <ShieldCheck size={48} data-id="element-146" data-mp="qnpz8w0rce3p" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy" data-id="element-147" data-mp="qmex10myneep">
            🛡️ Complete 7-Day Money-Back Guarantee
          </h2>
          <div className="space-y-6 text-lg text-slate max-w-2xl mx-auto" data-id="element-148" data-mp="p01j2cs0vbcd">
            <p data-id="element-149" data-mp="tymjac79xv0t">
              Open the complete coaching system. Explore the seven volumes. Review the
              bonuses. Use the material in your coaching.
            </p>
            <p className="font-medium text-navy" data-id="element-150" data-mp="yrfn8xux4zbu">
              If you feel the material is not clear, practical or useful for your coaching
              needs, contact us within 7 days.
            </p>
            <p className="text-navy font-bold text-xl" data-id="element-151" data-mp="62qkkue7slxz">
              We&apos;ll refund your purchase according to the guarantee conditions.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}